import { createSlice } from '@reduxjs/toolkit';

export const contentSlice = createSlice({
  name: 'content',
  initialState: {
    actionButtonText: '',
    supportURI: 'https://support.compodium.com/hc/en-us/requests/new',
    showSupport: true,
    showActionButton: true,
  },
  reducers: {
    setActionButtonText: (state, action) => {
      state.actionButtonText = action.payload;
    },
    setSupportURI: (state, action) => {
      state.supportURI = action.payload;
    },
    setShowSupport: (state, action) => {
      state.showSupport = action.payload;
    },
    setShowActionButton: (state, action) => {
      state.showActionButton = action.payload;
    },
  },
});

export const {
  setActionButtonText,
  setSupportURI,
  setShowSupport,
  setShowActionButton,
} = contentSlice.actions;

export default contentSlice.reducer;
